import { render, staticRenderFns } from "./ResponsiveSection.vue?vue&type=template&id=05481b40&scoped=true&"
import script from "./ResponsiveSection.vue?vue&type=script&lang=js&"
export * from "./ResponsiveSection.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveSection.vue?vue&type=style&index=0&id=05481b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05481b40",
  null
  
)

export default component.exports